// extracted by mini-css-extract-plugin
var _1 = "Outlined-moduleactive__OrSNs";
var _2 = "Outlined-modulebasic__HONzY";
var _3 = "Outlined-modulegrey__UGOOF";
var _4 = "Outlined-moduleoutlined__zsOu_";
var _5 = "Outlined-moduleskeleton__IIPCl";
export { _1 as "active", _2 as "basic", _3 as "grey", _4 as "outlined", _5 as "skeleton" }
